/**
 * 004 — Resolución de prellenados ✍️ y copy 🏛 (usado por el render).
 * Regla del diccionario: **campo vacío ≠ apagar** — un ✍️ vacío usa el prellenado
 * del sistema; apagar es su interruptor 🎚. Estas funciones son puras y testeables
 * sin el render (cubren C3/C6).
 */
import { PRELLENADOS, NOTA_EVENTO, momento, vestimenta } from './system-catalog';

/** Devuelve `value` si tiene contenido; si está vacío/undefined, el `fallback`. */
export function orDefault(value: string | null | undefined, fallback: string): string {
  const v = (value ?? '').trim();
  return v.length > 0 ? v : fallback;
}

export function resolveHistoriaTexto(value?: string | null): string {
  return orDefault(value, PRELLENADOS.historiaTexto);
}
export function resolveHistoriaFrase(value?: string | null): string {
  return orDefault(value, PRELLENADOS.historiaFrase);
}
export function resolveRegalosMensaje(value?: string | null): string {
  return orDefault(value, PRELLENADOS.regalosMensaje);
}
export function resolveEventoNota(
  tipo: 'religiosa' | 'civil' | 'recepcion',
  value?: string | null,
): string {
  return orDefault(value, NOTA_EVENTO[tipo]);
}

/** Nombre e icono de un momento del itinerario (🏛 catálogo, o `'otro'` con texto libre). */
export function resolveMomento(id: string, libre?: string): { nombre: string; icon: string } {
  if (id === 'otro') return { nombre: libre?.trim() || 'Otro', icon: 'sparkles' };
  const m = momento(id);
  return m ? { nombre: m.nombre, icon: m.icon } : { nombre: id, icon: 'sparkles' };
}

/** Copy de un código de vestimenta (🏛 catálogo). */
export function resolveVestimentaCopy(codigo: string): string {
  return vestimenta(codigo)?.copy ?? '';
}
